import {RegistryOfficeRepo} from "../api/registry-office.repo";
import {Injectable} from "@angular/core";
import {DuckDbHelper} from "./duckdb.helper";
import {OrgDto} from "../dto/org.dto";
import {SearchRequest} from "../dto/search/search-table.dto.req";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {SearchRegistryOfficeRes} from "../dto/search/search-registry-office.res";
import {SearchFilterResponse} from "../dto/search/search-table.dto.res";
import {RegistryOfficeDto} from "../dto/registry-office.dto";

/**
 * Der Export fuehrt keine Tabelle `registry_office`. Sie gehoerte zum Bestattungsmodul, das nie
 * produktiv gewesen ist und aus dem Exportschema entfernt wurde — siehe
 * `plans/completed/iron-backup-vollstaendigkeit-plan.md`, Abschnitt 1.
 *
 * Wie {@link DeathDuckDb} antwortet dieses Repo leer, statt eine Abfrage zu stellen, die im Viewer mit
 * „table does not exist" scheitern wuerde.
 */
@Injectable({providedIn: 'root'})
export class RegistryOfficeDuckDb extends RegistryOfficeRepo {

  public override getByIdCached(): Observable<WrapperDto<RegistryOfficeDto>> {
    return DuckDbHelper.dataObs('RegistryOfficeDto', new RegistryOfficeDto());
  }

  public override search(_org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchRegistryOfficeRes>> {
    const result = new SearchRegistryOfficeRes({
      items: [],
      hits: 0,
      page: request.page,
      pageSize: request.pageSize,
      sortField: request.sortField,
      sortOrder: request.sortOrder,
      filters: request.filters.map((f) => new SearchFilterResponse(f))
    });
    return DuckDbHelper.dataObs('SearchRegistryOfficeRes', result);
  }
}
